module.exports = __webpack_public_path__ + "static/img/menageService3.93707708.png";